'use strict';

import NumberView from 'views/record/subfields/Number';

class IntegerField extends NumberView{
}

export default IntegerField;
